"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var classnames_1 = __importDefault(require("classnames"));
var react_1 = __importStar(require("react"));
var index_1 = __importStar(require("../Icon/index"));
var index_2 = __importDefault(require("../ProgressIndicator/index"));
var Collapsible = /** @class */ (function (_super) {
    __extends(Collapsible, _super);
    function Collapsible(props) {
        var _this = _super.call(this, props) || this;
        _this.toggleCollapsible = function () {
            _this.setState({
                open: !_this.state.open,
            }, function () {
                if (_this.props.onStateChange) {
                    _this.props.onStateChange(_this.state.open);
                }
            });
        };
        var defaultOpen = true;
        if (props.defaultOpen !== undefined) {
            defaultOpen = props.defaultOpen;
        }
        else if (props.open !== undefined) {
            defaultOpen = props.open;
        }
        _this.state = {
            open: defaultOpen,
        };
        return _this;
    }
    Collapsible.getDerivedStateFromProps = function (props, state) {
        if (props.open !== undefined && props.open !== state.open) {
            return {
                open: props.open,
            };
        }
        return null;
    };
    Collapsible.prototype.render = function () {
        var _a;
        var _b = this.props, buttons = _b.buttons, className = _b.className, title = _b.title, error = _b.error, loading = _b.loading, safe = _b.safe;
        var children = this.props.children;
        var open = this.state.open;
        var baseClassName = "emankit__collapsible_container";
        if (!open && safe) {
            children = null;
        }
        var cn = classnames_1.default(baseClassName, className, (_a = {},
            _a[baseClassName + "--closed"] = !open,
            _a[baseClassName + "--error"] = error,
            _a[baseClassName + "--loading"] = loading,
            _a));
        var buttonData = null;
        if (buttons) {
            buttonData = buttons(this.state);
        }
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        var titleSize = Math.max(Math.min(this.props.titleSize, 12), 2);
        var countedTitleSize = open && buttons ? titleSize : 12;
        var buttonSize = 12 - titleSize || 12;
        return (react_1.default.createElement("div", { className: cn },
            react_1.default.createElement("div", { className: classnames_1.default(baseClassName + "__header", "row") },
                react_1.default.createElement("div", { className: classnames_1.default("col-md-" + countedTitleSize, baseClassName + "__title") },
                    react_1.default.createElement("div", { className: "header_clickable", onClick: this.toggleCollapsible },
                        react_1.default.createElement(index_1.default, { className: baseClassName + "__icon", icon: open ? index_1.IconType.ArrowBottom : index_1.IconType.ArrowRight, width: 32, height: 32 }),
                        react_1.default.createElement("h2", null, title))),
                react_1.default.createElement("div", { className: classnames_1.default("col-md-" + buttonSize, baseClassName + "__buttons") }, buttonData)),
            react_1.default.createElement("div", { className: baseClassName + "__children" },
                loading && react_1.default.createElement(index_2.default, { local: true, overlay: "light" }),
                children)));
    };
    Collapsible.defaultProps = {
        line: true,
        error: false,
        titleSize: 4,
    };
    return Collapsible;
}(react_1.PureComponent));
exports.default = Collapsible;
//# sourceMappingURL=index.js.map